export default __webpack_public_path__ + "7a2c2e765ec0a8c7fba9c3c6ea25c5a8.woff";